// extracted by mini-css-extract-plugin
export var markdown = "_s4-0";
export var tableWrapper = "_s4-1";